import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {MatDialog} from '@angular/material';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {Message} from 'src/app/core/class/message';
import {delay, map} from 'rxjs/internal/operators';
import {ErrorCode} from '../constants/error-code';
import {RestApi} from '../models/rest-api.model';
import {_} from 'underscore';
import {environment} from '../../../environments/environment';
import {EnvService} from './env.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  /**
   * list of rest-api handling by caller (not by interceptor)
   */
  event: any;
  callerHandlingErrorRestApis: RestApi[] = [];
  BASE_URL = 'http://localhost:8091/api';
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    })
  };

  constructor(
    private httpClient: HttpClient,
    public dialog: MatDialog,
    private message: Message,
    private env: EnvService
  ) {
    this.BASE_URL = environment.is_private_app ? environment.private_api_endpoint : environment.public_api_endpoint;
    // if (!environment.is_private_app) {
    //   this.BASE_URL = `${window.location.protocol}//${window.location.host}/scontract-web-api-public/api`;
    // }

    /**
     * giữ nguyên 3 dòng này từ 38-40 để auto build chạy không bị lỗi
     * if (!environment.is_private_app) {
     * this.BASE_URL = `${window.location.protocol}//${window.location.host}/scontract-web-api-public/api`;
     * }
     * */
    // this.BASE_URL = "http://172.18.1.44/scontract-web-api/api"
    // this.BASE_URL = "http://localhost:8080/api"
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    // if (!env.deploy_on_k8s && !env.is_private_app) {
    //   this.BASE_URL = `${window.location.protocol}//${window.location.host}/scontract-web-api-public/api`;
    // }
  }

  /**
   *  Add Url to get error from api for POST method
   */
  public addUrlToHandlingErrorRestApis(path) {
    this.handleErrorRequest(path, 'POST');
  }

  /**
   *  Add Url to get error from api for PUT method
   */
  public addUrlToHandlingErrorRestApisPut(path) {
    this.handleErrorRequest(path, 'PUT');
  }

  /**
   * Handle error of request
   * @param path path api
   * @param method method request
   */
  public handleErrorRequest(path, method: string) {
    const requestUrl = this.BASE_URL + path;
    const requestRestApi = new RestApi(method, requestUrl);
    this.callerHandlingErrorRestApis.push(requestRestApi);
  }

  /**
   *  Remove Url
   */
  public removeUrlToHandlingErrorRestApis() {
    this.callerHandlingErrorRestApis.pop();
  }

  /**
   *  Get method
   */
  public get(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params})
      .pipe(catchError(this.formatErrors));
  }

  /**
   *  Get method chay background: header X-Silent-Loading de interceptor khong block UI
   */
  public getSilently(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      'X-Silent-Loading': '1'
    });
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params})
      .pipe(catchError(this.formatErrors));
  }

  /**
   *  Get method with anonymous token
   */
  public getWithAnonymousToken(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      Authorization: localStorage.getItem('approvalToken') ? `Bearer ${localStorage.getItem('approvalToken')}` : undefined,
    });
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params})
      .pipe(catchError(this.formatErrors));
  }

  /**
   *  fetch data for autocomplete
   */
  public fetch(path: string, params: HttpParams = new HttpParams()): Promise<any> {
    const query = params.get('filter');
    return this.httpClient.get<any>(this.BASE_URL + path, {...this.options, params}).pipe(
      map(result => {
        if (query) {
          return result.data;
        }
        return result.data;
      }),
      delay(500))
      .toPromise();
  }

  /**
   *  fetch data for autocomplete
   */
  public fetchData(path: string, params: HttpParams = new HttpParams()): Promise<any> {
    const query = params.get('filter');
    return this.httpClient.get<any>(this.BASE_URL + path, {...this.options, params}).pipe(
      map(result => {
        if (query) {
          result.data.forEach(element => {
            element.spaceChar = ' - ';
            return element;
          });
          return result.data;
        }
        return result.data;
      }),
      delay(500))
      .toPromise();
  }

  public fetchDataAuto(path: string): Promise<any> {
    return this.httpClient.get<any>(this.BASE_URL + path, {...this.options}).pipe(
      map(result => {
        result.data.forEach(element => {
          element.spaceChar = ' - ';
          // return element;
        });
        return result.data;
      }),
      delay(500))
      .toPromise();
  }

  public getFile(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params, responseType: 'blob', withCredentials: true})
      .pipe(
        catchError(this.formatErrors)
      );
  }

  /**
   *  Get file chay background: header X-Silent-Loading de interceptor khong block UI
   */
  public getFileSilently(path: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      'X-Silent-Loading': '1'
    });
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params, responseType: 'blob', withCredentials: true})
      .pipe(
        catchError(this.formatErrors)
      );
  }

  public getFileWithResponse(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });

    return this.httpClient
      .get(this.BASE_URL + path, {
        ...this.options,
        params,
        responseType: 'blob',
        observe: 'response',
        withCredentials: true
      })
      .pipe(catchError(this.formatErrors));
  }
  public getFileWithName(path: string, resultImportExcelName: string, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      resultImportExcelName: resultImportExcelName
    });
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params, responseType: 'blob', withCredentials: true})
      .pipe(
        catchError(this.formatErrors)
      );
  }

  public getFilePostMethod(path: string, body: any, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
    });
    return this.httpClient
      .post(this.BASE_URL + path, body, {...this.options, params, responseType: 'blob', withCredentials: true})
      .pipe(
        catchError(this.formatErrors)
      );
  }

  /**
   *  Post file chay background: header X-Silent-Loading de interceptor khong block UI
   */
  public getFilePostSilently(path: string, body: any, params: HttpParams = new HttpParams()
  ): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      'X-Silent-Loading': '1'
    });
    return this.httpClient
      .post(this.BASE_URL + path, body, {...this.options, params, responseType: 'blob', withCredentials: true})
      .pipe(
        catchError(this.formatErrors)
      );
  }

  public actionDownloadFile(path: string): void {
    const a = document.createElement('a');
    a.href = this.BASE_URL + path;
    // a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
  }

  public put(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .put(this.BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  /**
   * Make put request and check version
   * @param path: any
   * @param body: any
   * @param callBack: any
   * @param noCallBack: any
   */
  public putAndCheckVersion(path: string, body: object = {}, callBack: any, noCallBack: any, errCallback?: any) {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    const requestUrl = this.BASE_URL + path;
    const requestRestApi = new RestApi('PUT', requestUrl);
    this.callerHandlingErrorRestApis.push(requestRestApi);
    this.httpClient
      .post(requestUrl, JSON.stringify(body), this.options)
      .subscribe((rs: any) => {
          // check if response has error or not
          if (errCallback && !rs.success) {
            errCallback(rs);
          } else {
            const response: any = rs;
            if (response && response.code === ErrorCode.VersionDuplicate) {
              const dialogRef = this.dialog.open(WarningComponent, {
                width: '350px',
                data: this.message.getMessage(response.message)
              });
              dialogRef.afterClosed().subscribe(rss => {
                if (rss) {
                  const newBody: any = body;
                  newBody.skipVersion = true;
                  this.httpClient
                    .put(this.BASE_URL + path, JSON.stringify(newBody), this.options)
                    .pipe()
                    .subscribe(() => {
                      callBack();
                    });
                } else {
                  noCallBack();
                }
              });
            } else if (response && response.code === ErrorCode.TaxCodeDuplicate) {
              noCallBack(response.code);
            } else {
              callBack();
            }
          }
        },
        err => {
          // console.log('Error in putAndCheckVersion', err);
          this.callerHandlingErrorRestApis = _.reject(this.callerHandlingErrorRestApis, (el: RestApi) => {
            return el.method === requestRestApi.method && el.url === requestRestApi.url;
          });
        }
        , () => this.callerHandlingErrorRestApis = _.reject(this.callerHandlingErrorRestApis, (el: RestApi) => {
          return el.method === requestRestApi.method && el.url === requestRestApi.url;
        }));
  }

  public post(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  /**
   *  Post method chay background: header X-Silent-Loading de interceptor khong block UI
   */
  public postSilently(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      'X-Silent-Loading': '1'
    });
    return this.httpClient
      .post(this.BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public postWithParams(path: string, params: any): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, {}, { ...this.options, params })
      .pipe(catchError(this.formatErrors));
  }

  public postWithToken(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      'InstanceID': localStorage.getItem('InstanceId') == null ? '' : localStorage.getItem('InstanceId'),
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      Authorization: localStorage.getItem('approvalToken') ? `Bearer ${localStorage.getItem('approvalToken')}` : undefined,
    });
    return this.httpClient
      .post(this.BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public postFilter(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, body, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public postFormData(path: string, body: object = {}, options: any = {}, isCustomUrl=false): Observable<any> {
    // KHÔNG set Content-Type: FormData cần browser tự set multipart + boundary
    // (đặt cứng application/json làm BE 400 vì mất boundary)
    this.options.headers = new HttpHeaders({
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });

    // options.headers (vd: X-Silent-Loading) phải đè lên default, không bị ghi mất
    // (HttpHeaders bản Angular này không có merge() -> copy từng header bằng set())
    let mergedHeaders = this.options.headers;
    if (options && options.headers instanceof HttpHeaders) {
      options.headers.keys().forEach(key => {
        mergedHeaders = mergedHeaders.set(key, options.headers.get(key));
      });
    }
    const new_option = {
      ...this.options,
      ...options,
      headers: mergedHeaders
    }

    const formData = new FormData();
    for (const [key, value] of Object.entries(body)) {
      if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    }

    let requestUrl = this.BASE_URL + path;

    if(isCustomUrl){
      requestUrl = path;
    }
    // if (path.endsWith("generate-image")) {
      // requestUrl = `http://127.0.0.1:8081/${path}`;
      // requestUrl = `http://10.207.252.82:8624/scontract-web-api/api/image/generate-image`;
    // }
    return this.httpClient
      .post(requestUrl, formData, new_option)
      .pipe(catchError(this.formatErrors));
  }

  public postJson(path: string, body: object = {}, options = {}, isCustomUrl = false): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      'Content-Type': 'application/json'
    });
  
    let new_option = {
      ...this.options,
      ...options
    };
  
    let requestUrl = this.BASE_URL + path;
  
    if (isCustomUrl) {
      requestUrl = path;
    }
  
    return this.httpClient
      .post(requestUrl, body, new_option)
      .pipe(catchError(this.formatErrors));
  }

  public postUpload2(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      // 'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, body, this.options);
  }

  public postUpload(path: string, body: object = {}): Observable<any> {
    this.options.headers = new HttpHeaders({
      // 'Content-Type': 'application/json',
      // 'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient
      .post(this.BASE_URL + path, body, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public postFileBase64(path: string, body: object = {}, options = {}, isCustomUrl = false): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });

    const new_option = {
      ...this.options,
      ...options
    };

    let requestUrl = this.BASE_URL + path;
    if (isCustomUrl) {
      requestUrl = path;
    }
    return this.httpClient
      .post(requestUrl, body, new_option)
      .pipe(catchError(this.formatErrors));
  }

  public delete(path: string): Observable<any> {
    this.options.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId')
    });
    return this.httpClient.delete(this.BASE_URL + path, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }

  /**
   * Get base url of web api.
   */
  public getBaseUrl() {
    return this.BASE_URL;
  }

  public shoudIngoreHanldingError(restApi: RestApi): boolean {
    return _.findWhere(this.callerHandlingErrorRestApis, restApi);
  }

  /**
   *  Get method change header
   */
  public getHeaders(path: string, params: HttpParams = new HttpParams(), header: HttpHeaders): Observable<any> {
    this.options.headers = header;
    return this.httpClient
      .get(this.BASE_URL + path, {...this.options, params})
      //  .get(path, {...this.options, params})
      .pipe(catchError(this.formatErrors));
  }

  public uploadFileAdminbyFile(path: string, body: any): Observable<any> {
    return this.httpClient
      .post(this.BASE_URL + path, body)
      .pipe(catchError(this.formatErrors));
  }

  public checkType(path: string, body: any): Observable<any> {
    return this.httpClient
      .post(this.BASE_URL + path, body)
      .pipe(catchError(this.formatErrors));
  }
}
